import React from "react";
import { Clock } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function OvertimeDashboard() {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 h-full">
      {/* Left Column - How it works */}
      <div className="bg-white border-r py-6 px-8 h-full">
        <h2 className="text-2xl font-bold text-zinc-800 mb-2">Overtime</h2>
        <p className="text-zinc-600 mb-8">
          Understand and manage your department&apos;s overtime workflow
        </p>

        {/* How it works */}
        <div className="mt-8">
          <div className="flex items-center gap-2 mb-4">
            <svg
              className="w-5 h-5 text-zinc-800"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
              />
            </svg>
            <h3 className="text-lg font-semibold text-zinc-800">How it works</h3>
          </div>
          <ol className="space-y-3 text-zinc-600">
            <li className="flex gap-3">
              <span className="font-semibold">1.</span>
              <span>
                Technician submits an overtime request with details and
                category.
              </span>
            </li>
            <li className="flex gap-3">
              <span className="font-semibold">2.</span>
              <span>
                Supervisor reviews and forwards to you (manager) with an
                optional note.
              </span>
            </li>
            <li className="flex gap-3">
              <span className="font-semibold">3.</span>
              <span>
                You review and approve or reject, with full visibility into the
                forwarding chain and overtime details.
              </span>
            </li>
          </ol>
        </div>
      </div>

      {/* Right Column - Other options */}
      <div className="bg-white py-6 px-8 h-full">
        <h2 className="text-2xl font-bold text-zinc-800 mb-2">Other options</h2>
        <p className="text-zinc-600 mb-6">
          Quick links for your department&apos;s overtime management
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {/* Overtime Requests */}
          <button
            onClick={() => navigate("/manager/overtime/requests")}
            className="bg-white border border-zinc-200 rounded-lg p-4 hover:shadow-md hover:border-zinc-300 transition-all text-left flex justify-start items-start"
          >
            <div className="flex items-start justify-start space-x-4">
              <div className="bg-[#CCB1E3] p-3 rounded-lg">
                <Clock className="w-5 h-5 text-black stroke-[1.5]" />
              </div>
              <div className="flex-1">
                <h3 className="font-medium text-sm tracking-tight text-zinc-800 mb-1">
                  Overtime Requests
                </h3>
                <p className="text-sm leading-tight text-zinc-500">
                  Review and decide on your employees&apos; overtime requests.
                </p>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
